import React from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import Convert from '../../common/Convert'
import GsuiteAuth from '../../components/Auth/GsuiteAuth'

const propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
}

export default class OpenFaxModal extends React.Component {
    constructor(props) {
        super(props);
        const roleData = JSON.parse(GsuiteAuth.get('DATA')) || []
        const roleDataMap = (roleData.length&&roleData.length>0)?
        roleData.reduce((acc, roleDatum)=>{
        acc[roleDatum.page_id]=roleDatum
        return acc
        },{})
        :{}
        this.state = {
            copied:false,
            open:false,            
            data:[],
            roleDataMap
        };
    }
    
    render() {
        const {
            value,
            data,
            name,
            onClick
        } = this.props
        const columnObject = name&&Convert.key_split(name)
        
        const displayValue = (data)?data[columnObject.column]:value
        return (
            <>
                {displayValue&&<span onClick={(this.state.roleDataMap["K1_01"] && this.state.roleDataMap["K1_01"].data_view_flag===1)?onClick:()=>{}}
                    className="pointer copy_hilight"
                >
                    {displayValue}
                    {displayValue&&<i style={{marginLeft:"10px"}}className="fa fa-fax" />}
                </span>}
            </>
        );
    }
}
OpenFaxModal.propTypes = propTypes;